interface ErrorStateProps {
  title?: string;
  message?: string;
}

export const ErrorState = ({
  title = "Something went wrong",
  message,
}: ErrorStateProps) => {
  return (
    <div className="h-[calc(100vh-4rem)] flex items-center justify-center">
      <div className="text-center">
        <p className="text-destructive mb-2">{title}</p>
        {message && <p className="text-sm text-muted-foreground">{message}</p>}
      </div>
    </div>
  );
};
